import { render } from "./KnowledgeModal.vue?vue&type=template&id=2c4afdd6"
import script from "./KnowledgeModal.vue?vue&type=script&lang=js"
export * from "./KnowledgeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__